import { render } from "./LiveIg.vue?vue&type=template&id=68ad0ee2"
import script from "./LiveIg.vue?vue&type=script&lang=js"
export * from "./LiveIg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__